import { render, staticRenderFns } from "./ListingDetails.vue?vue&type=template&id=54f27f91"
import script from "./ListingDetails.vue?vue&type=script&lang=js"
export * from "./ListingDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports